const isSiteReset = (siteData) => Boolean(siteData && siteData.resetAt);

export default isSiteReset;
